import { Check } from "lucide-react";
import { imgUrl } from "@/components/landing/useProducts";
import { label } from "./ProductEditors";

export const RelatedPicker = ({ value, onChange, currentId, products }) => {
  const choices = products.filter((p) => p.id !== currentId);
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : value.length < 4 ? [...value, id] : value);
  return (
    <div data-testid="pf-related">
      <span className={label}>Suggested products (“Complete the look” · up to 4 · shown in the quick view, bag and cart)</span>
      {!choices.length ? (
        <p className="text-xs text-[#5f5e5a]">Add more products first to suggest them here.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {choices.map((p) => {
            const on = value.includes(p.id);
            return (
              <button key={p.id} type="button" data-testid={`pf-related-${p.slug}`} onClick={() => toggle(p.id)} aria-pressed={on}
                className={`flex items-center gap-2.5 rounded-xl border p-2 text-left transition-colors ${on ? "border-[#0a0a0b] bg-[#0a0a0b] text-white" : "border-[#e3e2dc] bg-[#ffffff] hover:border-[#ff2a85]"}`}>
                <span className="h-10 w-8 shrink-0 rounded-md overflow-hidden bg-[#f3f2ec]">{p.image && <img src={imgUrl(p.image)} alt="" className="h-full w-full object-cover object-top" />}</span>
                <span className="flex-1 min-w-0 text-[11px] font-medium leading-tight truncate">{p.name}{!p.active && <span className={`block font-mono-d text-[8px] uppercase tracking-[0.15em] ${on ? "text-white/60" : "text-[#5f5e5a]"}`}>Hidden</span>}</span>
                <span className={`h-5 w-5 rounded-full border flex items-center justify-center shrink-0 ${on ? "border-[#ff2a85] bg-[#ff2a85]" : "border-[#c9c8c2]"}`}>{on && <Check size={11} strokeWidth={3} />}</span>
              </button>
            );
          })}
        </div>
      )}
      <p className="mt-2 text-[11px] text-[#5f5e5a]">Leave empty to automatically suggest other pieces from the same category.</p>
    </div>
  );
};
